import script from "./AccountView.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountView.vue?vue&type=script&setup=true&lang=js"

import "./AccountView.vue?vue&type=style&index=0&id=55e57994&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55e57994"]])

export default __exports__